import axios from '../../config/axios.js';
import Alpine from 'alpinejs';

function createKasirNews() {
  return {
    hydrated: false,
    loading: false,
    articles: [],
    createUrl: '#',
    editUrlBase: '',
    search: '',
    filterStatus: '',

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.articles = cfg.articles || [];
        this.createUrl = cfg.createUrl || '#';
        this.editUrlBase = cfg.editUrlBase || '';
      } catch (e) {
        console.error('kasirNews config error', e);
      }
      this.hydrated = true;
    },

    editUrl(id) {
      return `${this.editUrlBase}/${id}/edit`;
    },

    async fetch() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/news', {
          params: { search: this.search, status: this.filterStatus, per_page: 20 },
        });
        this.articles = data.data || [];
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat artikel.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async remove(a) {
      const ok = await window.confirmDialog?.({
        title: 'Hapus artikel?',
        message: `Hapus "${a.title}"?`,
        confirmText: 'Hapus',
        variant: 'danger',
      });
      if (ok === false) return;
      try {
        await axios.delete(`/api/v1/kasir/news/${a.id}`);
        window.toast?.('Artikel dihapus.', 'success');
        await this.fetch();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirNews', createKasirNews);
